import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            gap: remCalc(16),
            justifyContent: {base: 'center', xl: 'flex-start'},
            p: {base: remCalc(16), xl: remCalc(24)},
        },
        text: {textStyle: 'head-xsmall', color: 'text.default'},
        time: {
            boxSize: remCalc(78),
            backgroundColor: 'background.light',
            borderRadius: remCalc(2),
            textStyle: 'head-large',
            color: 'text.default',
            fontWeight: '700',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            _after: {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: 0,
                width: '100%',
                height: remCalc(2),
                backgroundColor: 'background.default',
                transform: 'translateY(-50%)',
                zIndex: 0,
            },
        },
        timeNumber: {
            zIndex: 1,
            textStyle: 'head-large',
        },
        counterBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: remCalc(8),
        },
    },
    variants: {
        black: {
            text: {color: 'text.inverse'},
        },
    },
    parts: ['container', 'text', 'time', 'timeNumber', 'counterBox'],
}
